import { render, staticRenderFns } from "./Assessment.vue?vue&type=template&id=7be477f1&scoped=true"
import script from "./Assessment.vue?vue&type=script&lang=js"
export * from "./Assessment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7be477f1",
  null
  
)

export default component.exports